import { render, staticRenderFns } from "./goods-image.vue?vue&type=template&id=df67fd3e&scoped=true"
import script from "./goods-image.vue?vue&type=script&lang=js"
export * from "./goods-image.vue?vue&type=script&lang=js"
import style0 from "./goods-image.vue?vue&type=style&index=0&id=df67fd3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df67fd3e",
  null
  
)

export default component.exports